import { createApp } from "vue";
import mitt from "mitt";

import App from "./App.vue";
import store from "./store";
import router from "./router";

import "ant-design-vue/dist/antd.css";
import "@/style/normalize.css";
import "@/style/reset.css";
import "@/style/common.scss";
import "@/assets/sass/style.scss";

import { storage } from "@/utils";
// {
//   // 开发时先写死token
//   window.localStorage.setItem(
//     "token",
//     "KB8rjzGkagJgrH9QLHQJUHOBATZoOiKH9--kFN9FBg1nO19TQRJIb8i_Q7u0o3nU"
//   );
// }
const token = window.localStorage.getItem("token");
if (token) {
  try {
    // 原token缓存的是字符串 '"abcd123"'
    storage.set("token", JSON.parse(token)); // key：qgxf_training2_token
  } catch (error) {
    //
  }
}

const app = createApp(App);

const emitter = mitt();

// 通过 app.provide(key, value) 全局注入一个属性 name
app.provide("emitter", emitter);

app.use(store).use(router).mount("#app");
